const initStickyBottomBar = function () {
    window.addEventListener('load', () => {
        let bottomElem = document.querySelector(".stick-up-bottom-element");
        let bottomBar = document.querySelector(".sticky-bottom-bar");
        let offset = 0; 
        try {
            offset = parseInt(bottomBar.dataset.offset);
        } catch {}

        if(bottomBar && bottomElem) {
            window.addEventListener("scroll", () =>updateBar(offset), false);
        }

        function updateBar() {
            let bottomElemPos = bottomElem.getBoundingClientRect().y;
            let bottomElemHeight = bottomElem.getBoundingClientRect().height;
            let bottomBarPos = bottomBar.getBoundingClientRect().y;

            if (bottomBarPos >= bottomElemPos + offset) {
                bottomBar.style.position = "relative";
                bottomBar.classList.add('sticked-on');
            }

            let docHeight = Math.max(
                document.documentElement["clientHeight"],
                document.body["scrollHeight"],
                document.documentElement["scrollHeight"],
                document.body["offsetHeight"],
                document.documentElement["offsetHeight"]
            );

            // console.log('trigger pos', docHeight - bottomElemHeight + offset);
            if (window.innerHeight + window.scrollY < docHeight - bottomElemHeight + offset) {
                if (bottomBar.style.position == "relative") {
                    bottomBar.style.position = "fixed";
                    bottomBar.classList.remove('sticked-on');
                }
            }
        }
    });
};
export default initStickyBottomBar;